import type { TourHistoryItem } from "../api/ToursApi";
import type { TourCardStatus } from "../types/history";

// Сводим статусы всех прогонов периода в один статус карточки.
// Приоритет:
//   1. есть pending/processing  -> pending (ещё в работе; processing для UI = pending);
//   2. иначе есть completed      -> success;
//   3. иначе (все failed)        -> error.
// Пустой список сюда не передаётся (пустой период рендерится плейсхолдером).
export function aggregateCardStatus(
  items: TourHistoryItem[]
): TourCardStatus {
  const inProgress = items.some(
    (i) => i.status === "pending" || i.status === "processing"
  );
  if (inProgress) return "pending";

  if (items.some((i) => i.status === "completed")) return "success";

  return "error";
}
